export const blurb =
  'BREEZE offers volume discounts to users located at either one site or at multiple sites within one country. Please complete the form below to receive a quote for multiple licenses.';
export const productTitle = 'Product Information';
export const personalTitle = 'Your Information';
export const companyTitle = 'Company Information';
export const helpTitle = 'How can we help you?';

export const link = 'Request Quote';
